import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenidComponent } from './simple-icons-openid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenidComponent ],
    exports:      [ SimpleIconsOpenidComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenidModule {}
